/*
 * (c) copyright 2021 International Road Dynamics Inc. and related companies.
 * All rights reserved.
 * Copyright as an unpublished work.
 *
 * This file contains confidential information of International
 * Road Dynamics Inc. and related companies, and should be treated as proprietary
 * and confidential.
 *
 * The use, copying, disclosure or modification of the
 * programs and/or source code is prohibited unless
 * otherwise provided for in the license or confidentiality
 * agreements.
 *
 * Any copy must contain this copyright notice.
 */

import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
